module.exports = __webpack_public_path__ + "961f6b429a581fa17b423d2f99897c7d.jpg";